// import { useI18n } from "vue-i18n";
import { PUSH_NOTIFICATION } from "../../../common/store/actions";
import store from "../../../store";
import { TOGGLE_AUTH_POPUP } from "../../authentication/store/actions";
import { ADD_TO_WATCHLIST, REMOVE_FROM_WATCHLIST } from "../../sell/store/actions";

export default function() {
    // const i18n = useI18n();

    const addToWatchList = (kit) => {

        if (store.getters.isAuthenticated !== false) {
            store
                .dispatch(ADD_TO_WATCHLIST, { kit_id: kit.id })
                .then(() => {
                    store.dispatch(PUSH_NOTIFICATION, {
                        title: kit.title,
                        subtitle: kit.condition_name,
                        content: "Saved to Watchlist",
                        imageUrl: "/assets/icons/watchlist.png"

                    });
                })
                .catch((response) => {});
        } else {
            store.dispatch(TOGGLE_AUTH_POPUP, true);
        }
    }

    const removeFromWatchlist = (kit) => {

        if (store.getters.isAuthenticated !== false) {
            store
                .dispatch(REMOVE_FROM_WATCHLIST, { kit_id: kit.id })
                .then(() => {
                    store.dispatch(PUSH_NOTIFICATION, {
                        title: kit.title,
                        subtitle: kit.condition_name,
                        content: i18n.t("landing.removed-from-watch-list"),
                        imageUrl: "/assets/icons/watchlist.png"
                    });
                })
                .catch((response) => {});
        } else {
            store.dispatch(TOGGLE_AUTH_POPUP, true);
        }
    }

    const kitExistInWatchList = (kit_id) => {
        return false;
    }

    return {
        addToWatchList,
        removeFromWatchlist,
        kitExistInWatchList
    }
}